import React, { Component } from 'react';
import { Input, Button, Form } from 'antd';
import { Link } from 'react-router-dom';
import routes from '@achievable-me/tundra-wizard/routes';
import logoSrc from '$assets/logoWithText.png';

import styles from './form.scss';

class SignInForm extends Component {
  onFinish = (values) => {
    this.props.signIn({ variables: { input: { ...values } } });
  };

  render() {
    const { loading } = this.props;

    return (
      <Form onFinish={this.onFinish} className={styles.form}>
        <Form.Item>
          <img className={styles.logo} src={logoSrc} />
        </Form.Item>
        <div className={styles.header}>Sign in</div>
        <Form.Item
          name="email"
          rules={[{ required: true, message: 'Please input your email!' }]}
        >
          <Input
            autoComplete="username"
            prefix={<i className="fal fa-user" />}
            placeholder="Email"
          />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[{ required: true, message: 'Please input your password!' }]}
        >
          <Input
            autoComplete="current-password"
            prefix={<i className="fal fa-lock" />}
            type="password"
            placeholder="Password"
          />
        </Form.Item>
        <Form.Item>
          <Button
            data-aaa="signInSubmit"
            type="primary"
            htmlType="submit"
            block
            loading={loading}
          >
            Sign in
          </Button>
          <div className={styles.links}>
            <Link to={routes.auth.forgotPassword}>Forgot password</Link>
            <Link data-aaa="signUpLink" to={routes.auth.signUp}>
              Sign up
            </Link>
          </div>
        </Form.Item>
      </Form>
    );
  }
}

export default SignInForm;
